<template>
	<div class="leftO">
<!--		<breadcrumb :routerList="[{title:'消息中心'}]" />-->
    <Breadtabsheader/>
		<div style="margin: 0.22rem 0.38rem 0 0.32rem;background:#fff;padding: 0.4rem 0.4rem 0.4rem 0.4rem;">
      <el-form :inline="true" class="demo-form-inline h-formBorder">
        <!--赵恺11.20加查询条件-->
        <el-form-item>
            <el-input v-model="query.title" clearable @keyup.enter.native="search"  placeholder="请输入标题或内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="search" size="mini"> 查询</el-button>
        </el-form-item>


      </el-form>

			<div style="position:relative;">
				<div class="buttonBox" style="margin-top: 0.1rem;">
					<div class="buttons" :class="{'active':tabindex == 0}"  :key="0"
						 @click="searchByA(0)">消息提醒
					</div>
					<div class="buttons" :class="{'active':tabindex == 1}"  :key="1"
						 @click="searchByA(1)">系统公告
					</div>
				</div>
				<el-form :inline="true" class="demo-form-inline h-formBorder"
						 style="position: absolute;right:0;bottom: 0;display: flex;align-items: center;">
					<el-form-item>
						<el-button v-auth="'publishMsg'" class="h-btn h-formBtn h-bggreen" @click="openPublish">发布消息</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="content-xin" style="margin-bottom: 40px;">
				<div class="t-row" v-for="(obj,i) in this.$store.getters.msglist.records" :key="i" @click="openDetail(obj.text,obj.infoId,obj.fileId,obj.id,obj.cuname,obj.topUp)">
					<div class="t-label">
						<span :class="{'roundTwo':obj.userchecked==0}"></span>
						<span class="yubao">{{obj.title}}</span>
            <span class="itemTitle">
              <i>{{obj.title}}</i>
              <b v-if="'0' == obj.topUp" class="b2">置顶</b>
              <b v-if="'0' == obj.iturgent" class="b1">加急</b>
            </span>
					</div>
					<div style="display:flex;align-items:center;justify-content:space-between;margin-top:0.05rem;">
						<div class="t-message" v-html="obj.text">{{obj.text}}</div>
						<div class="t-time">
							<span class="date" style="font-size: 12px;color: #999">{{obj.cdate?$util.riQi7(obj.cdate):''}}</span>
						</div>
					</div>
				</div>
				<div style="padding-top: 30px;">
					<pagination :page="query" @query="search"/>
				</div>
			</div>
		</div>
		<div>
			<el-dialog :visible.sync="dialogFormVisible" class="h-dialog2" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
				<div class="h-dialogImg">
					<div class="h-disTable">
						<div class="h-tableCell">
							<h1>系统消息详情</h1>
						</div>
					</div>
				</div>
				<div class="h-formLine">
					<el-form ref="form"
							 :inline="true" class="demo-ruleForm h-formbLine h-dialogForm yhxxfj">
            <el-form-item label="" class="h-elformWrap-1" style="width: 100%;">
              <span class="itemTitle">
              <b class="b22" v-if="closeTopUp" @click="configCloseTopUp()">取消置顶</b>
            </span>
            </el-form-item>
						<el-form-item label="消息" class="h-elformWrap-1" style="width: 100%;">
							<el-input  style="width: 100%;" :disabled="true" v-html="messageDetail" v-model="messageDetail"></el-input>
						</el-form-item>
						<el-form-item label="附件" class="h-elformWrap-1" style="margin-bottom: 0.2rem">
							<brupload
									:refid="this.fileId"
									reftype="发布消息-附件"
									:uploadflag="false"
									:delflag="false"
									:showtime="false">
							</brupload>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<!-- <el-button class="h-btn h-bBtn h-bgblue" @click="goBack">返回</el-button> -->
					<el-button class="h-btn h-bgblue" @click="goBack">我知道了</el-button>
					<el-button v-if="this.userIt == this.userNow" class="h-btn h-formBtn h-bgred" @click="del(idIt)">删除</el-button>
				</div>
			</el-dialog>
		</div>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible2" class="h-dialog2" @close="cancelPublish">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>发布系统消息</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding: 0.2rem">
				<el-form :model="dialogForm" ref="dialogForm" :inline="true"
						 class="demo-ruleForm h-formbLine h-formbLine1">
					<div class="h-rowCon" style="padding-bottom: 0;">
						<div class="h-pieceIn2">
							<div class="h-pieceCon2">
								<div class="h-formLine">
									<el-form-item label="标题" class="h-elformWrap-1" style="padding-right: 0.4rem">
										<el-input v-model="dialogForm.title" placeholder="请输入" class="h-txtareaBox" rows="4"></el-input>
									</el-form-item>

									<el-form-item label="类型" class="h-elformWrap-1" style="padding-right: 0.4rem">
                                        <el-select v-model="dialogForm.announcement" placeholder="请选择" style="width: 100%">
                                            <el-option label="消息" value="0"></el-option>
                                            <el-option label="公告" value="1"></el-option>
                                        </el-select>
									</el-form-item>

									<el-form-item label="内容" class="h-elformWrap-1" style="padding-right: 0.4rem">
										<el-input type="textarea" v-model="dialogForm.content" placeholder="请输入" class="h-txtareaBox" rows="4"></el-input>
									</el-form-item>
									<el-form-item label="角色" class="h-elformWrap-1" style="padding-right: 0.4rem">
										<el-select
												multiple
												filterable
												v-model="dialogForm.roles"
												placeholder="请选择"
												style="width: 100%">
											<el-option
													v-for="(item,index) in rolelist"
													:key="item.id"
													:label="item.name"
													:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
                  <el-row style="width: 100%">
                    <el-col :span="12">
                      <el-form-item label="置顶" style="width: 100%;">
                        <el-select v-model="dialogForm.topUp" placeholder="请选择">
                          <el-option label="是" value="0"></el-option>
                          <el-option label="否" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" style="width: 50%;">
                      <el-form-item label="加急" style="width: 100%;">
                        <el-select v-model="dialogForm.iturgent" placeholder="请选择">
                          <el-option label="是" value="0"></el-option>
                          <el-option label="否" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
									<el-form-item label="附件" class="h-elformWrap-1" style="padding-right: 0.4rem;margin-bottom: 0;">
										<brupload
												:refid="refid"
												reftype="发布消息-附件"
												:uploadflag="true"
												:delflag="true"
												:showtime="false">
										</brupload>
									</el-form-item>
								</div>
							</div>
						</div>
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				 <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelPublish">取消</el-button>
				 <el-button class="h-btn h-bBtn h-bgblue" @click="publish">发布</el-button>
			</div>
		</el-dialog>

	</div>
</template>
<script>
    import { mapState } from 'vuex'
	import ss from '@/api/SystemService';
	export default {
		data(){
		    return {
                pageParams:{
                    pageSize:10,
                    pageNo:1,
                    total:0,
                    announcement: null,
				},
				userNow: null,
				userIt: null,
				idIt: null,
                tabindex:0,
				fileId: '',
				refid: this.$util.getUuid(),
				messageDetail:'',
				dialogFormVisible: false,
          allRoleByUsercode:[{id:''}],
          allRoleByUsercodeFlag:false,
          infoId:'',
          closeTopUp:false,
				dialogFormVisible2: false,
				dialogForm:{
					title: '',
					content: '',
					announcement: null,
					roles: '',
          iturgent:'',
          topUp:'',
				},
				rolelist:[
					{
						name:'',
						id:''
					}
				]
			}
		},
        computed: {
		    query:function () {
				var q = this.pageParams;
				q.total = this.$store.getters.msglist.total;
				console.log(this.$store.getters.msglist,"我看看都有什么内容");
				return q;
          	}
		},
		created(){
			this.getAllRoles();
			this.userNow = this.$store.getters.user.username;
		},
		methods:{
            search(){
                this.$store.dispatch('searchMsgPage',this.query);
			},
            searchByA(index){
                this.tabindex = index;
                this.pageParams.announcement = index;
                this.$store.dispatch('searchMsgPage',this.query);
            },
			openDetail(detail,infoId,fileId,id,cuname,topUp) {
              console.log(topUp)
        if ('0' == topUp){
          this.closeTopUp = true;
        }else {
          this.closeTopUp = false;
        }
				this.dialogFormVisible = true;
				this.messageDetail = detail;
				this.idIt = id;
				this.userIt = cuname;
				if (fileId && fileId != '') {
					this.fileId = fileId;
				}
        this.infoId = infoId
				this.$store.dispatch('selectChecked',infoId);
			},
      configCloseTopUp(){
        //关闭置顶的信息
        console.log(this.infoId)
        ss.messageService.cancelTopUp({id:this.infoId}).then(res => {
          if (res.f){
            this.closeTopUp = false;
          }
        })
      },
			goBack() {
				this.dialogFormVisible = false;
				this.$store.dispatch('searchCheckedTotal',this.query);
				this.fileId = '';
				this.search();
			},
			openPublish(){
        ss.RoleService.getAllRoleByUsercode({userid:this.$store.getters.user.usercode}).then(rd => {
          console.log(rd)
          this.allRoleByUsercode = rd;
          this.allRoleByUsercode.forEach(d => {
            if ('pingtaishenpi' === d.id){
              this.allRoleByUsercodeFlag = true;
              return;
            }
          });
          if (this.allRoleByUsercodeFlag){
            let a = this.rolelist.filter(d => 'swyl_gndailishang' === d.id || 'swyl_xiaoshoujl' === d.id)
            this.rolelist = a
          }
        });
				this.dialogFormVisible2 = true;
				this.dialogForm = {
					title:'',
					content:'',
					announcement: null,
					roles:'',
          iturgent:'1',
          topUp:'0',
				};
			},
			cancelPublish(){
				this.dialogFormVisible2 = false;
				this.dialogForm = {
					title:'',
					content:'',
					announcement: null,
					roles:''
				};
			},
			publish() {
            	var flag = true;
            	if (!this.dialogForm.title || this.dialogForm.title == '') {
            		this.$msg.msge("标题，内容，角色缺一不可！");
					flag = false;
					return false;
				}
				if (!this.dialogForm.content || this.dialogForm.content == '') {
					this.$msg.msge("标题，内容，角色缺一不可！");
					flag = false;
					return false;
				}
				if (!this.dialogForm.roles || this.dialogForm.roles == '') {
					this.$msg.msge("标题，内容，角色缺一不可！");
					flag = false;
					return false;
				}
                if (!this.dialogForm.announcement || this.dialogForm.announcement == null) {
                    this.$msg.msge("请选择消息/公告类型！");
                    flag = false;
                    return false;
                }
				if (flag) {
					var role = '';
					if (this.dialogForm.roles && this.dialogForm.roles.length > 0) {
						for (var i = 0; i < this.dialogForm.roles.length; i++) {
							role = role + this.dialogForm.roles[i] + ","
						}
					}
					console.log(role);
					var mesg = {
						title: this.dialogForm.title,
						content: this.dialogForm.content,
						announcement: this.dialogForm.announcement,
						roles: role,
						fileId: this.refid
					}
					console.log(mesg);
					ss.messageService.publishMessage(mesg).then(rd => {
						if (rd.f == true) {
							this.$msg.msgs(rd.msg);
							this.dialogFormVisible2 = false;
							this.dialogForm = {
								title:'',
								content:'',
								announcement: null,
								roles:''
							};
							this.refid = this.$util.getUuid();
							this.search();
						} else {
							this.$msg.msge(rd.msg);
						}
					})
				}
			},
			getAllRoles(){
				ss.RoleService.getAllRoles().then(rd => {
					this.rolelist = rd;
				})
			},
			del(id){
			    var obj = {id:id};
                this.$msg.confirm("确认删除?", () => {
                    ss.messageService.deleteFlagById(obj).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.goBack();
                    })
                })
			}
		}
	}
</script>
<style scoped>
	.left {
		width: 96%;
		overflow: auto;
		background-color: rgb(255, 255, 255);
		margin: 0.22rem 0.38rem 0 0.32rem;
		padding-bottom: 65px;
		border: 1px solid #E2E2E2;
		padding: 0.1rem 0.4rem 0.4rem 0.4rem;
		display: flex;
		flex-direction: column;
	}
	.msgDetail{
		width: 100%;
		height: auto;
		word-wrap:break-word;
		word-break:break-all;
		overflow: hidden;
	}
	.title {
		border-bottom:1px solid #ccc;
		height: 60px;
		line-height: 60px;
		font-size: 0.16rem;
	}

	.t-row {
		padding: 0.1rem 0;
		border-bottom: 1px solid #ccc;
		cursor: pointer;
	}

	.t-label {
		display: flex;
		align-items: center
	}
	.yubao {
		margin-right: 10px;
		font-weight: normal;
	}
	.roundOne {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		margin-right: 10px;
		background-color: #F90000;
	}

	.roundTwo{
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: #F90000;
		margin-right: 10px;
	}
	.t-time, .t-message {
		color: #7B7B7B;
		font-size: 0.14rem;
	}
	.date {
		margin-right: 0.2rem;
	}
	.t-more div {
		color: #ccc;
	}
	.sendmeg{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.buttonBox {
		border-bottom: 1px solid #d9dfe9;
		display: flex;
		height: 40px;
		align-items: center
	}

	.buttonBox .buttons {
		width: 77px;
		height: 100%;
		line-height: 40px;
		font-size: 0.16rem;
		color: #333;
		background: #f0f4fb;
		border: 1px solid #e1e8f4;
		margin-left: 20px;
		text-align: center;
		cursor: pointer;
	}

	.buttonBox .buttons.active {
		border: 1px solid #2785e7;
		background: #2785e7;
		color: #fff;
	}

	.buttonBox .buttons:first-child {
		margin-left: 0
	}
</style>

<style>
	.h-formbLine2 .el-form-item__label {
		width: 26% !important;
	}

	.h-formbLine2 .el-form-item__content {
		width: 74% !important;
	}
	.h-elformWrap-k .el-form-item__content {
		width: 100% !important;
	}
	.yhxxfj .h-elformWrap-1 .el-form-item__label{
		width: 10%;
	}
	.yhxxfj .h-elformWrap-1 .el-form-item__content{
		width: 90%;
	}
  .itemTitle {
    display: flex;
    align-items: center;
    i {
      font-style: normal;
    }
    b {
      font-weight: normal;
      padding: 1px 4px;
      border: 1px solid #ccc;
      border-radius: 3px;
      margin-left: 8px;
    }
    .b1 {
      background-color: #f56c7c;
      border-color: #f56c7c;
      color:#fde2e2;
    }
    .b2 {
      background-color: #e6a23c;
      border-color: #e6a23c;
      color: #faecd8;
    }
  }
  .b22 {
    background-color: #e6a23c;
    border-color: #e6a23c;
    color: #faecd8;
  }
  .b22:hover{
    cursor: pointer;
  }
</style>
